import { render, staticRenderFns } from "./table65.vue?vue&type=template&id=2bdd931c&scoped=true"
import script from "./table65.vue?vue&type=script&lang=js"
export * from "./table65.vue?vue&type=script&lang=js"
import style0 from "./table65.vue?vue&type=style&index=0&id=2bdd931c&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd931c",
  null
  
)

export default component.exports